/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  if (document.getElementById('btn-64221020219')) {
  	document.getElementById('btn-64221020219').style.display = "none";
  }
})();

/*
var Case1 = document.getElementsByClassName("Select__Case1");
var product__1 = function() {
    var attribute = this.getAttribute("data-value");
  text_content= document.getElementById('Label__Case1').innerText;
    var text_content= document.getElementById('Label__Case1').innerText; 
    var reactListDiv = document.querySelector('.is-visible');
    if (reactListDiv) {
      reactListDiv.remove();
  }
    if(attribute != null)
    { 
      
      document.getElementById('Case1').value = attribute;
       
      if(document.getElementById('popover-case-1').getAttribute('aria-hidden') == 'false'){       
        document.getElementById('popover-case-1').setAttribute('aria-hidden', 'true'); 
        document.getElementById('popover-case-1').setAttribute('aria-hidden', true);  
       
       //document.getElementsByClassName("myDIV").classList.toggle("is-visible");
      }
  
     
      
    }else{      
      document.getElementById('Case1').value = text_content; 
      
     
    }
    

};

for (var i = 0; i < Case1.length; i++) {
  Case1[i].addEventListener('click', product__1, false);
}
var Case2 = document.getElementsByClassName("Select__Case2");
var text_content2= document.getElementById('Label__Case2').innerText; 
var reactListDiv = document.querySelector('.is-visible');
if (reactListDiv) {
  reactListDiv.remove();
}

var product__2 = function() {
    var attribute = this.getAttribute("data-value");
    text_content2= document.getElementById('Label__Case2').innerText;
    if(attribute != null)
    { 
      document.getElementById('Case2').value = attribute;
       
      if(document.getElementById('popover-case-2').getAttribute('aria-hidden') == 'false'){       
        document.getElementById('popover-case-2').setAttribute('aria-hidden', 'true');
        document.getElementById('popover-case-2').setAttribute('aria-hidden', true); 
       // element.classList.remove("is-visible");     
      }
    }else{      
      document.getElementById('Case2').value = text_content2; 
    }

};

for (var i = 0; i < Case2.length; i++) {
  Case2[i].addEventListener('click', product__2, false);
}
var Case3 = document.getElementsByClassName("Select__Case3");
var text_content3= document.getElementById('Label__Case3').innerText; 
var product__3 = function() {
    var attribute = this.getAttribute("data-value");   
    var reactListDiv = document.querySelector('.is-visible');
    text_content3= document.getElementById('Label__Case3').innerText;
    if (reactListDiv) {
      reactListDiv.remove();
  } 
   if(attribute != null)
   { 
     document.getElementById('Case3').value = attribute;
      
     
     if(document.getElementById('popover-case-3').getAttribute('aria-hidden') == 'false'){       
      document.getElementById('popover-case-3').setAttribute('aria-hidden', 'true');      
      document.getElementById('popover-case-3').setAttribute('aria-hidden', true);  
     // element.classList.remove("is-visible");    
    }
   }else{
     document.getElementById('Case3').value = text_content3; 

   }
};

for (var i = 0; i < Case3.length; i++) {
  Case3[i].addEventListener('click', product__3, false);
}*/